// Кнопка «Печать» на карточках инженерного блока.
//
// ЗАЧЕМ ОТДЕЛЬНЫЙ КОМПОНЕНТ, А НЕ ТРИ КНОПКИ. Кнопка тут — меньшая часть дела. Рядом с ней
// живут две вещи, которые обязаны быть одинаковыми на всех трёх карточках:
//   • возраст зеркала ДО нажатия. Человек должен видеть, насколько лист отстал от портала,
//     пока лист ещё на экране, а не когда он уже распечатан и подписан;
//   • честный ответ на заблокированное всплывающее окно. Лист открывается отдельным
//     документом (см. шапку lib/print73.ts), и браузер это иногда запрещает. Молчание в
//     ответ на нажатие читается как «сломалось».
//
// Печать НИЧЕГО НЕ ПИШЕТ. Ни в Bitrix, ни в 1С, ни на портал 73: это лист для человека.
import { useState } from 'react'

import { useСвежестьЗеркала73 } from '../api/p73'
import type { СвежестьЗеркала73 } from '../api/p73'
import { ПОРОГ_ТРЕВОГИ_МИН, возрастом, открытьЛист } from '../lib/print73'

interface Props {
  /** Собрать лист. Вызывается по нажатию: до него ни строки HTML не строится. */
  собрать: (свежесть: СвежестьЗеркала73 | null) => string
  /** Готовы ли данные записи. Пока нет — кнопка есть, но нажать нечего. */
  готово: boolean
  подпись?: string
}

export function PrintButton({ собрать, готово, подпись = '🖨 Печать' }: Props) {
  const св = useСвежестьЗеркала73()
  const [беда, setБеда] = useState('')

  const старейшее = св.data?.oldest_min ?? null
  const тревога = старейшее !== null && старейшее > ПОРОГ_ТРЕВОГИ_МИН

  const напечатать = () => {
    setБеда('')
    // Возраст спрашивать не обязательно: не ответило ядро — лист выйдет с честной
    // подписью «возраст данных получить не удалось», а не без подписи вовсе.
    const исход = открытьЛист(собрать(св.data ?? null))
    if (исход === 'blocked') {
      setБеда('Браузер не дал открыть окно печати. Разрешите всплывающие окна для этого'
        + ' адреса и нажмите ещё раз — лист открывается отдельной страницей.')
    }
  }

  return (
    <>
      <button type="button" disabled={!готово} onClick={напечатать}>{подпись}</button>
      <div className="hint">
        {св.isLoading && 'возраст зеркала уточняется…'}
        {!св.isLoading && !св.data && 'возраст зеркала неизвестен — ядро не ответило'}
        {!св.isLoading && св.data && (старейшее === null
          ? 'синк с порталом 73 ни разу не отмечался'
          : `зеркало сверялось с порталом ${возрастом(старейшее)}`)}
        {тревога && ' — лист выйдет с предупреждением'}
      </div>
      {беда && <div className="notice">{беда}</div>}
    </>
  )
}
